import Vue from 'vue'
import App from './App.vue'
import router from './router'
import scroll from '@/assets/js/scroll'
import 'jquery'
import 'jquery.nicescroll'
import './assets/css/main.less'

const scrollImpl = new scroll();
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.name != from.name){
    document.title = to.meta.title;
    scrollImpl.init();
  }
  next();
})

Vue.prototype.scrTo = (val)=>{scrollImpl.to(val)};
Vue.prototype.scrollImpl = scrollImpl;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
